<p>ccinstall-select works!</p>
